import { Col, Row } from "antd";
import { t } from "i18next";
import React from "react";

import { ISkladisteInformacijeProps } from "../../../../../../modules/ministry/ministry.types";
import { AkciznaMarkicaKategorijaProzivoda } from "../../../../../../modules/obligee/exciseStamps/exciseStamps.types";
import style from "./LicenceDetailsCenter.module.scss";

interface ILicenceDetailsCenterProps {
  dataLicence: ISkladisteInformacijeProps;
  kategorijaProizvodaId: AkciznaMarkicaKategorijaProzivoda | null;
}

export const LicenceDetailsCenter: React.FC<ILicenceDetailsCenterProps> = ({
  dataLicence,
  kategorijaProizvodaId,
}) => {
  const translateMeraValue = () => {
    if (dataLicence.meraVelicineSkladista === 1)
      return `${t("PLACEHOLDERS.POVRSINA")} :`;
    return `${t("PLACEHOLDERS.ZAPREMINA")} :`;
  };
  return (
    <Col span={24} className={style.mainContainer}>
      <Row>
        <Col span={12} className="pr-55">
          <Row className={style.leftCol}>
            <Col span={18} className="alignRight pr-7">
              <span className={style.fontSize}>
                {kategorijaProizvodaId ===
                AkciznaMarkicaKategorijaProzivoda.DUVAN
                  ? `${t(
                      "AKCIZNE_DOZVOLE.OSTVARENA_KOLICINA_PROIZVEDENIH_AKCIZNIH_PROIZVODA_U_PROTEKLOJ_KALENDARSKOJ_GODINI_U"
                    )} kg`
                  : t(
                      "AKCIZNE_DOZVOLE.OSTVARENA_KOLICINA_PROIZVEDENIH_AKCIZNIH_PROIZVODA_U_PROTEKLOJ_KALENDARSKOJ_GODINI"
                    )}
                :
              </span>
            </Col>
            <Col span={5}>
              <span className={style.fontSize}>
                {kategorijaProizvodaId ===
                AkciznaMarkicaKategorijaProzivoda.DUVAN
                  ? dataLicence.kolicinaProizvodaIzPrethodneGodineKg ?? "/"
                  : dataLicence.kolicinaProizvodaIzPrethodneGodine ?? "/"}
              </span>
            </Col>
          </Row>
          {kategorijaProizvodaId === AkciznaMarkicaKategorijaProzivoda.DUVAN ? (
            <Row className={style.leftCol}>
              <Col span={18} className="alignRight pr-7">
                <span className={style.fontSize}>
                  {t(
                    "AKCIZNE_DOZVOLE.OSTVARENA_KOLICINA_PROIZVEDENIH_AKCIZNIH_PROIZVODA_U_PROTEKLOJ_KALENDARSKOJ_GODINI_U_KOMADIMA"
                  )}
                  :
                </span>
              </Col>
              <Col span={5}>
                <span className={style.fontSize}>
                  {dataLicence.kolicinaProizvodaIzPrethodneGodineKomadi ?? "/"}
                </span>
              </Col>
            </Row>
          ) : (
            <></>
          )}
          <Row className={style.leftCol}>
            <Col span={18} className="alignRight pr-7">
              <span className={style.fontSize}>
                {kategorijaProizvodaId ===
                AkciznaMarkicaKategorijaProzivoda.DUVAN
                  ? `${t(
                      "AKCIZNE_DOZVOLE.PLANIRANE_KOLICINE_GODISNJE_PROIZVODNJE_AKCIZNOG_PROIZVODA_U"
                    )} kg`
                  : t(
                      "AKCIZNE_DOZVOLE.PLANIRANE_KOLICINE_GODISNJE_PROIZVODNJE_AKCIZNOG_PROIZVODA"
                    )}
                :
              </span>
            </Col>
            <Col span={5}>
              <span className={style.fontSize}>
                {kategorijaProizvodaId ===
                AkciznaMarkicaKategorijaProzivoda.DUVAN
                  ? dataLicence.planiranaProizvodnjaProizvodaKg ?? "/"
                  : dataLicence.planiranaProizvodnjaProizvoda ?? "/"}
              </span>
            </Col>
          </Row>
          {kategorijaProizvodaId === AkciznaMarkicaKategorijaProzivoda.DUVAN ? (
            <Row className={style.leftCol}>
              <Col span={18} className="alignRight pr-7">
                <span className={style.fontSize}>
                  {t(
                    "AKCIZNE_DOZVOLE.PLANIRANE_KOLICINE_GODISNJE_PROIZVODNJE_AKCIZNOG_PROIZVODA_U_KOMADIMA"
                  )}
                  :
                </span>
              </Col>
              <Col span={5}>
                <span className={style.fontSize}>
                  {dataLicence.planiranaProizvodnjaProizvodaKomadi ?? "/"}
                </span>
              </Col>
            </Row>
          ) : (
            <></>
          )}
          <Row className={style.leftCol}>
            <Col span={18} className="alignRight pr-7">
              <span className={style.fontSize}>
                {t(
                  "AKCIZNE_DOZVOLE.BR_SKLADISTA_ZA_KOJE_TRAZI_AKCIZNU_DOZVOLU"
                )}
                :
              </span>
            </Col>
            <Col span={5}>
              <span className={style.fontSize}>
                {dataLicence.brojSkladistaZaDozvolu}
              </span>
            </Col>
          </Row>
          <Row className={style.leftCol}>
            <Col span={18} className="alignRight pr-7">
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.ULICA_I_BROJ")}:
              </span>
            </Col>
            <Col span={5}>
              <span className={style.fontSize}>
                {dataLicence.ulicaSkladista}{" "}
              </span>
              <span className={style.fontSize}>
                {dataLicence.brojUliceSkladista}
              </span>
            </Col>
          </Row>
          <Row className={style.leftCol}>
            <Col span={18} className="alignRight pr-7">
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.POSTANSKI_BROJ")}:
              </span>
            </Col>
            <Col span={5}>
              <span className={style.fontSize}>
                {dataLicence.postanskiBrojSkladista}
              </span>
            </Col>
          </Row>
          <Row className={style.leftCol}>
            <Col span={18} className="alignRight pr-7">
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.MESTO_SKLADISTA")}:
              </span>
            </Col>
            <Col span={5}>
              <span className={style.fontSize}>
                {dataLicence.mestoSkladista}
              </span>
            </Col>
          </Row>
          <Row className={style.leftCol}>
            <Col span={18} className="alignRight pr-7">
              <span className={style.fontSize}>
                {t("AKCIZNE_DOZVOLE.OZNAKA_SKLADISTA")}:
              </span>
            </Col>
            <Col span={5}>
              <span className={style.fontSize}>
                {dataLicence.oznakaSkladista}
              </span>
            </Col>
          </Row>
          <Row className={style.leftCol}>
            <Col span={18} className="alignRight pr-7">
              <span className={style.fontSize}>{translateMeraValue()}</span>
            </Col>
            <Col span={5}>
              <span className={style.fontSize}>{dataLicence.meraVrednost}</span>
            </Col>
          </Row>
        </Col>
        <Col span={12} className="pl-85">
          <div className="pb-25">
            <span className={style.fontSize}>
              {t("AKCIZNE_DOZVOLE.OPIS_AKCIZNOG_SKLADISTA")}
            </span>
          </div>
          <div className="pb-25">
            <span className={style.fontSize}>{dataLicence.opisSkladista}</span>
          </div>
          <div className="pb-25">
            <span className={style.fontSize}>
              {t("AKCIZNE_DOZVOLE.OPIS_RADA_SISTEMA_RACUNOVODSTVA")}
            </span>
          </div>
          <div>
            <span className={style.fontSize}>
              {dataLicence.opisRadaRacunovodstva}
            </span>
          </div>
        </Col>
      </Row>
    </Col>
  );
};
